import {createContext, useEffect, useState} from "react";
import {jwtDecode} from "jwt-decode";
import axios from "axios";
import {useNavigate} from "react-router-dom";

export const UserContext = createContext()

export const UserProvider = ({children})=>{
    const[access_token,set_access_token] = useState(null)
    const [userData,setUserData] = useState(null)
    const[initializing,setInitializing] = useState(true)
    // const backEndUrl = "http://127.0.0.1:8000";
    const backEndUrl = "https://backend.cliffmutinda.com";
    const navigate = useNavigate()

    useEffect(()=>{
        const token = JSON.parse(localStorage.getItem("access_token"))
        if(token){
            set_access_token(token)
        }
        setInitializing(false)
    },[])

    useEffect(() => {
        if (access_token) {
            const verifyToken = async () => {
                try {
                    const claims = jwtDecode(access_token);
                    setUserData(claims);

                    // ✅ Await axios call
                    const response = await axios.get(`${backEndUrl}/is_access_token_valid`, {
                        headers: { Authorization: `Bearer ${access_token}` },
                    });

                    console.log("Token is valid:", response.data);
                } catch (error) {
                    console.error("Token check failed:", error);
                    localStorage.removeItem("access_token");
                    setUserData(null);
                    set_access_token(null);
                    navigate("/");
                }
            };

            verifyToken();
        } else {
            setUserData(null);
        }
    }, [access_token, navigate]);


    return(
        <UserContext.Provider value={{access_token,set_access_token,userData,setUserData,initializing,backEndUrl}}>
            {children}
        </UserContext.Provider>
    )
}